// context/LoaderContext.js
import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const LoaderContext = createContext();

export const useLoader = () => {
  return useContext(LoaderContext);
};

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};
// Add PropTypes validation for props
LoaderProvider.propTypes = {
  children: PropTypes.node.isRequired, // Validate that children are renderable and required
};
